import {useParams} from "react-router-dom";
import {useEffect} from 'react';
import {getProviderInfo} from '../api/provider'
import {Redirect} from 'react-router-dom';
import {useState} from 'react';
import {Loading} from '../components/Loading'

export default function LoginPage({onLogin}) {
    let {token} = useParams();
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getProviderInfo(token).then(data => {
            sessionStorage.setItem('token', token);
            onLogin(token, data)
            setSuccess(true);
        }).catch(() => setSuccess(false))
            .finally(() => setLoading(false))
    }, [token, onLogin])

    if (loading) {
        return <Loading />
    } else if (success) {
        return <Redirect to="/home" />
    } else {
        return <Redirect to="/error" />
    }

}
